module.exports = __webpack_public_path__ + "img/SMT_51_Ms_Maninderjit_Kaur_DO_Major_Singh.7756bdea.jpg";